export default __webpack_public_path__ + "static/media/black oreo full.86ca3fe6.png";